/// <reference types="./model.d.mts" />
import * as $bright from "../../bright/bright.mjs";
import * as $utils from "../../common/common/utils.mjs";
import * as $proposal_element from "../../common/data/proposal_element.mjs";
import * as $question from "../../common/data/proposal_element/question.mjs";
import * as $local_storage from "../../ds/web/browser/local_storage.mjs";
import * as $window from "../../ds/web/browser/window.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $float from "../../gleam_stdlib/gleam/float.mjs";
import * as $function from "../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $effect from "../../lustre/lustre/effect.mjs";
import * as $computed from "../data/model/computed.mjs";
import * as $state from "../data/model/state.mjs";
import * as $msg from "../data/msg.mjs";
import * as $proposals from "../data/proposals.mjs";
import * as $route from "../data/route.mjs";
import * as $scaffold from "../frontend/browser/scaffold.mjs";
import * as $guards from "../frontend/guards.mjs";
import * as $node from "../frontend/window/node.mjs";
import { Ok, toList, makeError, isEqual } from "../gleam.mjs";
import {
  unsubscribeScrolls as unsubscribe_scrolls,
  subscribeScrolls as subscribe_scrolls,
  syncContainerScrolls as sync_container_scrolls,
} from "./model.ffi.mjs";

export { sync_container_scrolls };

const FILEPATH = "src/data/model.gleam";

export function replace_proposal_tab(state, _) {
  return $bool.guard(
    state.loading.questions,
    $effect.none(),
    () => {
      return $bool.guard(
        state.loading.proposals,
        $effect.none(),
        () => {
          let $ = state.route;
          if ($ instanceof $route.Projects) {
            let $1 = $[0];
            if ($1 instanceof $route.Proposals) {
              let pid = $1.project_id;
              let route = $1.proposal;
              let $2 = $list.key_find(state.proposals.all, route.id);
              if ($2 instanceof Ok) {
                let proposal = $2[0];
                let tabs = $route.proposal_tabs(proposal);
                let default_tab = $route.default_proposal_tab(proposal);
                let tab = $option.unwrap(route.tab, default_tab);
                let contains_tabs = $list.contains(tabs, tab);
                return $bool.guard(
                  contains_tabs,
                  $effect.none(),
                  () => {
                    let _block;
                    let _record = route;
                    _block = new $route.ShowProposal(
                      _record.id,
                      _record.comment_id,
                      _record.page,
                      _record.question_id,
                      _record.sheet,
                      new None(),
                    );
                    let _pipe = _block;
                    let _pipe$1 = ((_capture) => {
                      return new $route.Proposals(pid, _capture);
                    })(_pipe);
                    let _pipe$2 = new $route.Projects(_pipe$1);
                    return $route.replace(_pipe$2);
                  },
                );
              } else {
                return $effect.none();
              }
            } else {
              return $effect.none();
            }
          } else {
            return $effect.none();
          }
        },
      );
    },
  );
}

function scroll_content_library(state, _, route) {
  if (route instanceof $route.DataSources) {
    let $ = route.source_id;
    if ($ instanceof Some) {
      let source_id = $[0];
      let is_loading = state.loading.content_library;
      return $bool.guard(
        is_loading,
        $effect.none(),
        () => {
          let _block;
          let _pipe = state.content_library.non_qna_sources;
          let _pipe$1 = $option.map(_pipe, (p) => { return p.elements; });
          _block = $option.unwrap(_pipe$1, toList([]));
          let sources = _block;
          return $bool.lazy_guard(
            $list.is_empty(sources),
            $effect.none,
            () => {
              return $effect.from(
                (_) => { return $scaffold.scroll_to_source(source_id); },
              );
            },
          );
        },
      );
    } else {
      return $effect.none();
    }
  } else if (route instanceof $route.QuestionBank) {
    let $ = route.source_id;
    if ($ instanceof Some) {
      let source_id = $[0];
      let is_loading = state.loading.content_library;
      return $bool.guard(
        is_loading,
        $effect.none(),
        () => {
          let _block;
          let _pipe = state.content_library.qna_sources;
          let _pipe$1 = $option.map(_pipe, (p) => { return p.elements; });
          _block = $option.unwrap(_pipe$1, toList([]));
          let sources = _block;
          return $bool.lazy_guard(
            $list.is_empty(sources),
            $effect.none,
            () => {
              return $effect.from(
                (_) => { return $scaffold.scroll_to_source(source_id); },
              );
            },
          );
        },
      );
    } else {
      return $effect.none();
    }
  } else if (route instanceof $route.PreviousProposals) {
    return $effect.none();
  } else if (route instanceof $route.Insights) {
    return $effect.none();
  } else if (route instanceof $route.NewQuestion) {
    return $effect.none();
  } else {
    return $effect.none();
  }
}

export function scroll_to_comment_target_effect(state, comment_id, target_id) {
  return $effect.from(
    (dispatch) => {
      return $node.timeout(
        600,
        () => {
          return $node.retry(
            10,
            () => {
              return $result.map(
                $node.questions_container_height(target_id),
                (heights) => {
                  return $node.timeout(
                    100,
                    () => {
                      let $ = state.proposals.focus_comment;
                      if ($ instanceof $option.Some) {
                        let id = $[0][0];
                        if (id === target_id) {
                          return $scaffold.scroll_to_comment(comment_id);
                        } else {
                          let _pipe = new $msg.UserToggleComment(
                            target_id,
                            heights[0],
                            [heights[1], heights[2]],
                          );
                          let _pipe$1 = new $msg.Proposal(_pipe);
                          dispatch(_pipe$1)
                          return $node.timeout(
                            100,
                            () => {
                              return $scaffold.scroll_to_comment(comment_id);
                            },
                          );
                        }
                      } else {
                        let _pipe = new $msg.UserToggleComment(
                          target_id,
                          heights[0],
                          [heights[1], heights[2]],
                        );
                        let _pipe$1 = new $msg.Proposal(_pipe);
                        dispatch(_pipe$1)
                        return $node.timeout(
                          100,
                          () => {
                            return $scaffold.scroll_to_comment(comment_id);
                          },
                        );
                      }
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function scroll_proposals(state, _, proposal) {
  let is_loading = state.loading.questions;
  let $ = proposal.question_id;
  if ($ instanceof Some) {
    let $1 = proposal.tab;
    if ($1 instanceof None) {
      let question_id = $[0];
      return $bool.lazy_guard(
        is_loading,
        $effect.none,
        () => {
          return $effect.from(
            (_) => { return $scaffold.scroll_to_question(question_id); },
          );
        },
      );
    } else {
      let $2 = proposal.comment_id;
      if ($2 instanceof Some) {
        let qid = $[0];
        let cid = $2[0];
        return $bool.lazy_guard(
          is_loading,
          $effect.none,
          () => { return scroll_to_comment_target_effect(state, cid, qid); },
        );
      } else {
        return $effect.none();
      }
    }
  } else {
    return $effect.none();
  }
}

export function scroll_to_element_in_screen(state, computed, _) {
  let $ = state.route;
  if ($ instanceof $route.ContentLibrary) {
    let content_library = $[0];
    return scroll_content_library(state, computed, content_library);
  } else if ($ instanceof $route.Projects) {
    let $1 = $[0];
    if ($1 instanceof $route.Proposals) {
      let proposal = $1.proposal;
      return scroll_proposals(state, computed, proposal);
    } else {
      return $effect.none();
    }
  } else {
    return $effect.none();
  }
}

export function compute_page_max(length, block_size) {
  let _block;
  let _pipe = length;
  let _pipe$1 = $int.to_float(_pipe);
  _block = $float.divide(_pipe$1, $int.to_float(block_size));
  let $ = _block;
  if (!($ instanceof Ok)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "data/model",
      198,
      "compute_page_max",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 6914,
        end: 7020,
        pattern_start: 6925,
        pattern_end: 6937
      }
    )
  }
  let page_max = $[0];
  let _pipe$2 = page_max;
  let _pipe$3 = $float.ceiling(_pipe$2);
  let _pipe$4 = $float.round(_pipe$3);
  let _pipe$5 = $int.subtract(_pipe$4, 1);
  return $int.max(_pipe$5, 0);
}

function compute_page_from_id(list_of_ids, block_size, target_id) {
  let _block;
  let _pipe = list_of_ids;
  let _pipe$1 = $list.index_map(_pipe, (x, i) => { return [i, x]; });
  let _pipe$2 = $utils.find_list_element_index(_pipe$1, target_id);
  _block = $result.unwrap(_pipe$2, 0);
  let element_position = _block;
  let _pipe$3 = element_position;
  let _pipe$4 = $int.add(_pipe$3, 1);
  let _pipe$5 = $int.to_float(_pipe$4);
  let _pipe$6 = $float.divide(_pipe$5, $int.to_float(block_size));
  let _pipe$7 = $result.unwrap(_pipe$6, 0.0);
  let _pipe$8 = $float.ceiling(_pipe$7);
  let _pipe$9 = $float.round(_pipe$8);
  let _pipe$10 = $int.subtract(_pipe$9, 1);
  return $int.max(_pipe$10, 0);
}

function compute_page_from_questions(questions, block_size, question_id) {
  let _pipe = questions;
  let _pipe$1 = $list.map(_pipe, (q) => { return q.id; });
  return compute_page_from_id(_pipe$1, block_size, question_id);
}

export function replace_proposal_question_page(state, computed, _) {
  return $bool.guard(
    state.loading.questions,
    $effect.none(),
    () => {
      let page_size = state.proposals.block_page_size;
      let $ = state.route;
      if ($ instanceof $route.Projects) {
        let $1 = $[0];
        if ($1 instanceof $route.Proposals) {
          let pid = $1.project_id;
          let route = $1.proposal;
          let $2 = route.question_id;
          if ($2 instanceof Some) {
            let question_id = $2[0];
            let questions = $proposals.get_questions(state.proposals, route.id);
            let sheet = $proposals.get_sheet_from_question_id(
              questions,
              question_id,
            );
            let _block;
            let _pipe = $list.group(questions, (q) => { return q[1].sheet; });
            let _pipe$1 = $dict.get(_pipe, sheet);
            _block = $result.unwrap(_pipe$1, toList([]));
            let questions_in_current_sheet = _block;
            let block_size = state.proposals.block_page_size;
            let _block$1;
            let _pipe$2 = questions_in_current_sheet;
            let _pipe$3 = $list.map(_pipe$2, (q) => { return q[1]; });
            let _pipe$4 = $list.sort(
              _pipe$3,
              (q1, q2) => { return $int.compare(q1.qa_order, q2.qa_order); },
            );
            _block$1 = compute_page_from_questions(
              _pipe$4,
              block_size,
              question_id,
            );
            let page = _block$1;
            let _block$2;
            let _block$3;
            let _record = route;
            _block$3 = new $route.ShowProposal(
              _record.id,
              _record.comment_id,
              page,
              _record.question_id,
              sheet,
              _record.tab,
            );
            let _pipe$5 = _block$3;
            let _pipe$6 = ((_capture) => {
              return new $route.Proposals(pid, _capture);
            })(_pipe$5);
            _block$2 = new $route.Projects(_pipe$6);
            let new_proposal_route = _block$2;
            let $3 = isEqual(new_proposal_route, state.route);
            if ($3) {
              return $effect.none();
            } else {
              return $route.replace(new_proposal_route);
            }
          } else {
            return $guards.require_page_more_than_0(
              route.page,
              (() => {
                let _pipe = new $route.ShowProposal(
                  route.id,
                  new None(),
                  0,
                  new None(),
                  new None(),
                  new None(),
                );
                let _pipe$1 = ((_capture) => {
                  return new $route.Proposals(pid, _capture);
                })(_pipe);
                return new $route.Projects(_pipe$1);
              })(),
              () => {
                let total = computed.displayed_questions_count;
                let page_max = compute_page_max(total, page_size);
                return $bool.guard(
                  route.page <= page_max,
                  $effect.none(),
                  () => {
                    let _block;
                    let _record = route;
                    _block = new $route.ShowProposal(
                      _record.id,
                      _record.comment_id,
                      page_max,
                      _record.question_id,
                      _record.sheet,
                      _record.tab,
                    );
                    let _pipe = _block;
                    let _pipe$1 = ((_capture) => {
                      return new $route.Proposals(pid, _capture);
                    })(_pipe);
                    let _pipe$2 = new $route.Projects(_pipe$1);
                    return $route.replace(_pipe$2);
                  },
                );
              },
            );
          }
        } else {
          return $effect.none();
        }
      } else {
        return $effect.none();
      }
    },
  );
}

export function find_element(state, proposal_id, element_id) {
  let _pipe = state.proposals.elements.by_proposal;
  let _pipe$1 = $dict.get(_pipe, proposal_id);
  return $result.try$(
    _pipe$1,
    (_capture) => { return $list.key_find(_capture, element_id); },
  );
}

export function unsubscribe_more_proposal(state) {
  let _pipe = state.proposals.more_unsubscriber;
  return $option.unwrap(_pipe, $effect.none());
}

export function save_access_token(access_token) {
  return $effect.from(
    (dispatch) => {
      if (access_token instanceof Some) {
        let access_token$1 = access_token[0];
        let $ = $local_storage.set_item("access-token", access_token$1);
        
        return dispatch(new $msg.ApplicationStoredAccessToken());
      } else {
        return $local_storage.remove_item("access-token");
      }
    },
  );
}

export function sync_questionnaire_scrolls(state, _) {
  return $effect.from(
    (_) => {
      let $ = state.route;
      if ($ instanceof $route.Overview) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.ContentLibrary) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Projects) {
        let projects = $[0];
        if (projects instanceof $route.OnGoing) {
          return unsubscribe_scrolls();
        } else if (projects instanceof $route.Previous) {
          return unsubscribe_scrolls();
        } else if (projects instanceof $route.ShowProject) {
          return unsubscribe_scrolls();
        } else if (projects instanceof $route.AddProject) {
          return unsubscribe_scrolls();
        } else if (projects instanceof $route.AddProposal) {
          return unsubscribe_scrolls();
        } else if (projects instanceof $route.EditProject) {
          return unsubscribe_scrolls();
        } else if (projects instanceof $route.EditProposal) {
          return unsubscribe_scrolls();
        } else {
          return $function.tap(
            undefined,
            (_) => {
              return $window.request_animation_frame(
                (_) => { return subscribe_scrolls(); },
              );
            },
          );
        }
      } else if ($ instanceof $route.CoPilot) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Settings) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Organization) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Analytics) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Support) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Login) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.SlackLogin) {
        return unsubscribe_scrolls();
      } else if ($ instanceof $route.Editor) {
        return unsubscribe_scrolls();
      } else {
        return unsubscribe_scrolls();
      }
    },
  );
}

export function comments_container_size(state) {
  return [
    state.window_dimensions,
    state.proposals.comment_displayed_opened,
    state.proposals.focus_comment,
  ];
}

export function recompute_questions_container_size(state, _, _1) {
  return $effect.from(
    (dispatch) => {
      return $function.tap(
        undefined,
        (_) => {
          return $window.request_animation_frame(
            (_) => {
              let $ = state.proposals.focus_comment;
              if ($ instanceof Some) {
                let element_id = $[0][0];
                let $1 = $node.questions_container_height(element_id);
                if ($1 instanceof Ok) {
                  let heights = $1[0];
                  let _pipe = new $msg.RecomputeQuestionsContainerHeights(
                    heights,
                  );
                  let _pipe$1 = new $msg.Proposal(_pipe);
                  return dispatch(_pipe$1);
                } else {
                  return undefined;
                }
              } else {
                return undefined;
              }
            },
          );
        },
      );
    },
  );
}

export function scroller_selector(state) {
  return [state.route];
}

export function proposal_page_selector(state) {
  return [state.route, state.loading.questions];
}
